<template>
  <el-aside width="auto" class="slider">
    <!-- <el-link :class="isCollapse?'logo logo-min':'logo'" target="_self"> -->
    <el-link class="logo" target="_self">
      <h4>商家后台管理系统</h4>
      <p>Management System</p>
    </el-link>
    <el-scrollbar class="default-scrollbar" v-model="menu" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
      <el-menu text-color="#ffffff"  active-text-color="#ffffff" :unique-opened='true'>
        <el-submenu v-for="(item , index) in menu" :key="item.menu_id" :index="item.title" @click.native="()=>item.menu_id=='1'? sandTabIndex():''">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.title}}</span>
          </template>
          <el-menu-item  v-if="citem.title != '报名列表'" :class="menuItemActive==citem.title?'el-menu-item is-actives ':'el-menu-item'" v-for="(citem , cIndex) in item.children" :key="citem.menu_id" :index="citem.title" :route="citem.uri" @click="sendTabs">
            <template slot="title">
              <span slot="title">
                <el-badge v-if="citem.reddot" class="header-icon-msg-item" :max="99" :value="citem.reddot">{{citem.title}}</el-badge>
                <span v-else>{{citem.title}}</span>
              </span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
  </el-aside>
</template>

<script>
export default {
  // props: ["isCollapse"],
  data () {
    return {
      menu: [],
      reddot: [],
      menuItemActive: "首页",
      indexActive:'',
    };
  },
  created () {
    this.getSlide();
  },
  watch: {
    updataOrderList () {
      // 获取到返回列表，更新列表
      if (this.updataOrderList) {
        this.updatedReddot();
      }
    },
    "$store.state.leaveConfirm":{
       handler:function(newVal,oldVal){
         if(newVal){
            this.menuItemActive = this.indexActive;  
         }
       }
     },
     "$store.state.orderCurrentTab":{
       handler:function(newVal,oldVal){
         if(newVal){
            this.menuItemActive = newVal;
         }
       }
     }
  },
  computed: {
    headTabsValue: {
      get: function () {
        return this.$store.state.headTabsValue;
      },
      set: function () { }
    },
    updataOrderList: {
      get: function () {
        return this.$store.state.updataOrderList;
      },
      set: function () { }
    }
  },
  methods: {
    sandTabIndex () {
      this.$store.dispatch("addHeadTab", {
        addTitle: "首页",
        addUrl: "index"
      });
    },
    sendTabs ($el) {
      // this.$store.dispatch("setHeadTabs2", [
      //   {
      //     title: $el.index,
      //     addNum: "1",
      //     content: $el.route,
      //     url: $el.route,
      //     close: false
      //   }
      // ])
      // console.log($el.index,$el.route)
      this.$store.dispatch("addHeadTab", {
        addTitle: $el.index,
        addUrl: $el.route
      });
      this.$store.dispatch("set_Status", $el.index);
      this.indexActive = $el.index;
      //添加选中样式
      if(!this.$store.state.showLeave){
        this.menuItemActive = $el.index;
      }
    },
    getMenu () {
      return this.$axios.get("/api/v1/admin/menus", { params: {} });
    },
    getReddot () {
      return this.$axios.get("/api/v1/compute/order/num", { params: {} });
    },
    updatedReddot () {
      this.$axios.all([this.getReddot()]).then(
        this.$axios.spread((perms) => {
          if (perms.data.status == "200") {
            this.reddot = perms.data.data;
            localStorage.setItem("orderReddot", JSON.stringify(this.reddot));
            this.menu.forEach((item, index) => {
              if (item.title == "订单管理") {
                item.children.forEach((citem, cindex) => {
                  if (citem.title == "待付款") {
                    citem.reddot = this.reddot.countOrderToPay;
                  } else if (citem.title == "待发货") {
                    citem.reddot = this.reddot.countOrderToDelivery;
                  } else if (citem.title == "退款中") {
                    citem.reddot = this.reddot.countOrderToRefunding;
                  } else if (citem.title == "待收货") {
                    citem.reddot = this.reddot.countOrderToDeliveried;
                  }
                });
              }
            });
          } else { this.$popup(perms.data.msg, "error"); }
        })
      )
    },
    getSlide () {
      this.$axios.all([this.getMenu(), this.getReddot()]).then(
        this.$axios.spread((acct, perms) => {
          if (acct.data.status == "200") {
            let list = acct.data.data.filter(item=>{
              return item.title != '文章管理'
            });
            // acct.data.data.splice(4, 1);
            this.menu = list;
            this.$store.dispatch('setUserMenu', this.menu)
          } else {
            this.$popup(acct.data.msg, "error");
          }
          if (perms.data.status == "200") {
            this.reddot = perms.data.data;
            localStorage.setItem("orderReddot", JSON.stringify(this.reddot));
            this.menu.forEach((item, index) => {
              if (item.title == "订单管理") {
                item.children.forEach((citem, cindex) => {
                  if (citem.title == "待付款") {
                    citem.reddot = this.reddot.countOrderToPay;
                  } else if (citem.title == "待发货") {
                    citem.reddot = this.reddot.countOrderToDelivery;
                  } else if (citem.title == "退款中") {
                    citem.reddot = this.reddot.countOrderToRefunding;
                  } else if (citem.title == "待收货") {
                    citem.reddot = this.reddot.countOrderToDeliveried;
                  }
                });
              }
            });
          } else { this.$popup(perms.data.msg, "error"); }
        })
      )
    }
  }
};
</script>

<style lang="less">
.el-menu:not(.el-menu--collapse) {
  // width: 240px;
}

.logo {
  width: 240px;
  height: 89px;
  box-sizing: border-box;
  padding: 24px !important;
text-align: left;
  transition: width 0.3s ease-out;
  h4 {
    display: block;
    width: 240px;
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 21px;
    color: #ffffff;
    margin: 0;
    margin-bottom: 4px;
    transition: all 0.3s ease-out;
  }
  p {
    display: block;
    width: 240px;
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
    margin: 0;
    transition: all 0.3s ease-out;
  }
  .el-link--inner {
    display: block;
    width: 100%;
    height: 100%;
    text-align: left;
  }
}

.logo-min {
  width: 69px;
  h4,
  p {
    opacity: 0;
  }
}

.slider {
  width:300px !important;
  height: 100%;
  overflow: hidden !important;
  color: #ffffff;
  // box-shadow:3px 0px 10px 0px rgba(83,91,112,0.56);
  border-radius:0px 30px 30px 0px;
  background-color: #151515;
  .el-link.is-underline:hover:after {
    border: none;
  }
  .el-menu {
    font-size: 16px;
    color: #ffffff;
    border-right: none;
    background-color: #151515;
  }
   .el-menu--inline{
    background:#2d2d2d;
  }
  .el-submenu:nth-of-type(1) .el-submenu__icon-arrow {
    display: none;
  }
  .el-submenu__title,
  .el-submenu__title i,
  .el-menu-item-group__title,
  .el-menu-item {
    color: #ffffff;
    text-align: left;
    font-size: 16px;
  }
  .el-menu-item {
    height:60px;
    line-height: 60px;
    padding-left: 60px !important;
  }
  .el-submenu .el-menu-item{
    height:60px;
    line-height: 60px;
  }
  .el-submenu__title:hover,
  .el-menu-item:hover {
    background-color: #FF3A3A !important;
  }
  .el-menu--collapse > .el-menu-item [class^="el-icon-"],
  .el-menu--collapse > .el-submenu > .el-submenu__title [class^="el-icon-"] {
    vertical-align: top !important;
  }
  .el-submenu__title {
    padding: 0 20px;
    padding-left:30px !important;
    height:60px;
    line-height: 62px;
    font-size: 16px;
    i:nth-of-type(1) {
      display: inline-block;
      vertical-align: top;
      transform: translateY(22px);
      width: 19px;
      height: 19px;
    }
    i:nth-of-type(1)::before {
      display: none;
    }
    i:nth-of-type(2)::before {
      content: "\E791" !important;
    }
  }
  .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
    transform: rotateZ(90deg);
  }
  .el-menu-item i {
    color: #ffffff;
  }
  .el-menu-item.is-active{
    background: initial;
  }
  .el-menu-item.is-actives {
    box-sizing: border-box;
    background-color: #FF3A3A !important;
    position:relative;
    
  }
  .el-menu-item.is-actives::before{
      content: "";
      display: inline-block;
      position: absolute;
      width: 6px;
      height: 24px;
      background: #fff;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
  }
  .el-badge__content {
    top: 25px !important;
    right: -8px !important;
    border: none;
  }
}

.el-aside .default-scrollbar {
  width: 100%;
  height: calc(100% - 89px);
}

.el-menu--vertical .el-badge__content.is-fixed {
  top: 29px;
  right: -6px;
}

.el-menu--vertical .el-menu--popup {
  padding: 0;
  .el-menu-item:hover {
    background-color: #0556fe !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/slider.vue